import { render, staticRenderFns } from "./ClinicFlags.vue?vue&type=template&id=6c41f943&"
import script from "./ClinicFlags.vue?vue&type=script&lang=js&"
export * from "./ClinicFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports